export const ADDROUTEINFO = "addRouterInfo"
export const ROUTER_STOREAGE_ROUTER_INFO = "routerStoe/addRouterInfo"
export const REMOVE_END_ROUTER = "removeEndRouter"
export  const GAINROUTERSPOP = "routerStoe/gainroutersPop"
export const ROUTER_STOREAGE_REMOVE_END_ROUTER = "routerStoe/removeEndRouter"



// WEBPACK FOOTER //
// ./src/vuex/routeStorage/type.js